/**
 * Cross domain communication library over sendMessage
 *
 * provides functionality for proper communication
 * (2 way communication - sending messages and receiving responses)
 *
 *
 * @author marian.cojoc@1and1.ro
 * @author ciprian.popovici@1and1.ro
 */
var utils, sender, receiver, responder;

/**
 * Utils name space to hold utilities functions
 */
utils = {
    //parseUri 1.2.2
    //(c) Steven Levithan <stevenlevithan.com>
    //MIT License
    //http://blog.stevenlevithan.com/archives/parseuri
    /**
     * this function splits any well-formated URI into it's parts
     * @param {string} str Well formated URI
     * @returns {Object} the parts of the URI
     */
    parseUri: function(str) {
        var o   = {
            strictMode: false,
            key: [
                "source",
                "protocol",
                "authority",
                "userInfo",
                "user",
                "password",
                "host",
                "port",
                "relative",
                "path",
                "directory",
                "file",
                "query",
                "anchor"
            ],
            q: {
                name: "queryKey",
                parser: /(?:^|&)([^&=]*)=?([^&]*)/g
            },
            parser: {
                strict: /^(?:([^:\/?#]+):)?(?:\/\/((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?))?((((?:[^?#\/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/,
                loose:  /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/
            }
        },
        m = o.parser[o.strictMode ? "strict" : "loose"].exec(str),
        uri = {},
        i = 14;

        while (i--) uri[o.key[i]] = m[i] || "";

        uri[o.q.name] = {};
        uri[o.key[12]].replace(o.q.parser, function ($0, $1, $2) {
            if ($1) uri[o.q.name][$1] = $2;
        });

        return uri;
    },

    postMessage: function (target, message) {
        //serialize
        if (typeof message !== "string") {
            message = JSON.stringify(message);
        }

        target.postMessage(message, "*");
    },

    /**
     * common point for registering message event listeners
     *
     * @param {function} handleMessage callback function
     */
    registerMessageEventListeners: function (handleMessage) {
        var preHandle = function (event) {

            if (typeof event.data === "string") {
                try {
                    event.realData = JSON.parse(event.data);
                } catch(e) {
                    //parsing failed, continue as it is ment as a string
                    event.readData = event.data;
                }
            }
            handleMessage(event);
        };
        //jQuery may not be available, so native event handling
        if (window.addEventListener) { //normal browser style
            window.addEventListener('message', preHandle, false);
        } else { //IE style
            window.attachEvent('onmessage', preHandle);
        }
    }
};


/**
 * the sender initiates the 2-way communication;
 * sends the message and optionally waits for a response
 */
sender = {};
(function () {
    //holds the message ids
    var messages = {};
    //default timeout to 5 seconds
    var timeout = 5000;
    var timeouts = {};
    /**
     * params structure: {
     *  success:<callback_function>,
     *  error:<callback_function>,
     *  timeout:<callback_function>,
     *  setTimeout: <number of miliseconds>
     * }
     */
    /**
     * used to initiate a communication
     *
     * @param {object} msg the message to send
     * @param {object} params callbacks and other options
     */
    this.sendMessage = function (msg, params) {
        msg = msg || {};
        //have a random id
        var messageId = 'm' + (Math.random() * (1 << 30)).toString(16);
        //if the sender expects a response back, it provides the callback
        if (params !== undefined ){

            if (params.timeout !== undefined) {
                if (params.setTimeout!==undefined) {
                    timeout = params.setTimeout;
                }
                var to = setTimeout(function() {
                    delete timeouts[messageId];
                    delete messages[messageId];
                    params.timeout();
                }, timeout);
                timeouts[messageId] = to;
            }
            messages[messageId] = params;
            msg.messageId = messageId;
        }
        //TODO: handle the targetOrigin
        utils.postMessage(window.top, msg); //send the message

    };
    /**
     * Handledresponses for sent messages
     * @param {object} e the message event
     */
    var handleMessage = function (e) {
        //do not handle own messages
        if (e.realData === undefined || e.realData.responseData === undefined) {
            return;
        }
        var messageId = e.realData.messageId;

        //clear the timeout
        if (timeouts[messageId] !== undefined) {
            clearTimeout(timeouts[messageId]);
            delete timeouts[messageId];
        }

        var params = messages[messageId];
        if (e.realData.success == true) {
            if (params.success !== undefined) {
                params.success(e.realData.responseData);
            }
        } else {
            if(params.error !== undefined){
                params.error(e.realData.responseData);
            }
        }
        delete messages[messageId];
    };
    /**
     * init function
     */
    this.init = function () {
        utils.registerMessageEventListeners(handleMessage);
    };

    this.init();

}).call(sender);

/**
 * the receiver waits for a message and optionally responds back..
 * ..by passing a responder object to the callback; letting the callback..
 * ..to do the actual responding
 * also handles the receiver callbacks function registration
 */
receiver = {};
(function () {

    var receiverCallbacks = {};
    /**
     * waits for messages and calls the registered callback for..
     * ..that message type
     * @param {object} e the message event
     */
    var handleMessage = function (e) {
        //do not handle own messages
        if (e.realData === undefined || e.realData.type === undefined) {
            return;
        }

        var payload = e.realData;
        if (receiverCallbacks[payload.type] !== undefined) {
            var rObj = new responder(payload, e.source);

            //accepts only from known sources
            var url_details = utils.parseUri(
                receiverCallbacks[payload.type].expectedOrigin
            );
            var expectedOriginUrl = url_details.protocol + '://' + url_details.host;
            if(url_details.port !== undefined && url_details.port !== ''){
                expectedOriginUrl = expectedOriginUrl + ':' + url_details.port;
            }
            //if the handler does not expect and origin, it handles all the messages
            if (receiverCallbacks[payload.type].expectedOrigin !== undefined
                && e.origin !== expectedOriginUrl) {
                return;
            }

            receiverCallbacks[payload.type].callback(payload.params, rObj);
            return;
        }
    };
    /**
     * register callback for a message type
     * @param {string} type
     * @param {function} callback
     * @param {string} exectedOrigin handle messages originating from here
     */
    this.registerReceiver = function (type, callback, expectedOrigin) {
        receiverCallbacks[type]={
            callback: callback,
            expectedOrigin: expectedOrigin
        };
    };
    /**
     * removes a callback for a message type
     *
     * @param {string} type the type of message
     * @returns {bool} true on successful removal, false otherwise
     */
    this.unregisterReceiver = function (type) {
        if (receiverCallbacks[type] === undefined) {
            return false;
        }
        return delete receiverCallbacks[type];
    };

    utils.registerMessageEventListeners(handleMessage);
}).call(receiver);
/**
 * this object gets passed to message handlers on the receiving part
 * to be used to trigger success or failure
 * @param payload
 * @param source
 * @returns {window.diy.crossDomain.responder}
 */
responder = function (payload, source) {
    this.payload = payload;
    this.source = source;
    /**
     * respond in case of success
     *
     * @param {string} response
     */
    this.respond = function (response) {
        var message={
            responseData: response,
            success: true,
            messageId: payload.messageId
        };

        //TODO: get the iframe to send to, for now send back to where it came from
        utils.postMessage(this.source, message);
    };
    /**
     * respond in case of error
     * @param {string} errorCode see: diy.appsApiConstants.errors
     */
    this.error = function (errorCode){
        var message = {};
        message.messageId = payload.messageId;
        message.success = false;
        message.responseData = {errorId: errorCode};
        //TODO: get the iframe to send to, for now send back to where it came from
        utils.postMessage(this.source, message);
    };
};

module.exports = {
    utils: utils,
    sender: sender,
    receiver: receiver,
    responder: responder
};


/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/external/crossDomain.js
 ** module id = 12
 ** module chunks = 0
 **/